export default {"src":"/_next/static/media/error-image.ed04a5e3.svg","height":124,"width":124,"blurWidth":0,"blurHeight":0};